<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn
          color="blue-accent-4"
          append-icon="mdi-pencil-outline"
          v-bind="props"
        >
          Editar
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Editar Área de Concentração</span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" validate-on="lazy submit">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-textarea
                    v-model="this.descricao"
                    required
                    label="Descrição*"
                    rows="3"
                    :rules="descricaoRules"
                  ></v-textarea>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-checkbox
                    v-model="this.fl_realizada"
                    label="Realizada"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*Campo obrigatório</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue-darken-1" variant="text" @click="submitForm">
            Atualizar
            <v-progress-circular
              v-if="this.isLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 * @module EditAreaConcentracao
 * @desc Modal com formulário para editar uma área de concentração.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o modal está visível.
 * @vue-data {string} [descricao=''] - Descrição da área de concentração.
 * @vue-data {boolean} [fl_realizada=false] - Flag que indica se a área de
 * concentração já foi realizada.
 * @vue-data {string} id_charter - O id do charter.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se a área de
 * concentração ainda está sendo atualizada.
 */
import axios from 'axios';

import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  props: {
    id: Number,
  },
  emits: ['areaConcentracaoEditada'],
  data: () => ({
    dialog: false,
    descricao: '',
    // eslint-disable-next-line camelcase
    fl_realizada: false,
    // eslint-disable-next-line camelcase
    id_charter: null,
    isLoading: false,
    descricaoRules: [
      (v) => !!v || 'Descrição é obrigatória',
      (v) =>
        (v && v.length <= 200) || 'Descrição deve ter no máximo 200 caracteres',
    ],
  }),
  created() {
    this.fetchAreaConcentracao(this.id);
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Realiza uma requisição HTTP para obter informações sobre uma área
     * de concentração.
     *
     * @param {Number} id O id da área de concentração.
     */
    async fetchAreaConcentracao(id) {
      try {
        const response = await axios.get(
          `${apiUrl}/api/v1/areaConcentracao/${id}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          },
        );
        this.descricao = response.data.areaC.descricao;
        // eslint-disable-next-line camelcase
        this.fl_realizada = response.data.areaC.fl_realizada;
        this.idAreaC = response.data.areaC.id_area_concentracao;
        // eslint-disable-next-line camelcase
        this.id_charter = response.data.areaC.id_charter;
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Realiza uma requisição HTTP para atualizar uma área de concentração.
     */
    async submitForm() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        const data = {
          descricao: this.descricao,
          // eslint-disable-next-line camelcase
          fl_realizada: this.fl_realizada,
          // eslint-disable-next-line camelcase
          id_charter: Number(this.id_charter),
        };
        try {
          this.isLoading = true;
          const response = await axios.put(
            `${apiUrl}/api/v1/areaConcentracao/${this.id}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          const idProjeto = this.$route.params.idProjeto;
          const idCharter = this.$route.params.id;

          this.$toast.success(response.data.msg);
          this.$emit('areaConcentracaoEditada', idCharter);
          this.$router.push(`/projects/${idProjeto}/Charters/${idCharter}`);
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoading = false;
          this.dialog = false;
        }
      }
    },
  },
};
</script>
